<div class="flex flex-col items-center text-center gap-4">
  <i *ngIf="icon" class="pvsc-icon text-[40px] text-color-sun-yellow icon-{{icon}}"></i>
  <mat-icon *ngIf="matIcon" [svgIcon]="matIcon"
            class="text-[40px] !h-[40px] !w-[40px] text-color-sun-yellow"></mat-icon>
  <img *ngIf="image" class="h-[314px] w-[314px] fill-sun-yellow bg-sun-yellow" src="assets/images/{{image}}"
       [alt]="imageAlt">
  <h5 class="text-color-blue1">{{title}}</h5>
  <div class="text-center w-[80%]">{{text}}</div>
</div>
